export const devicesReq = (filter, customerId) => {
  const REQ_BODY = {
    filters: {
      customerId: customerId,
      search: filter.search ? filter.search : '*',
      ruleAction: filter.ruleAction[0] ? filter.ruleAction : '*',
      status: filter.status[0] ? filter.status : '*',
      'sources.sourceType': filter['sources.sourceType'][0]
        ? filter['sources.sourceType']
        : '*',
      'destinations.destinationType': filter['destinations.destinationType'][0]
        ? filter['destinations.destinationType']
        : '*'
    },
    sort: {
      fieldName: filter.fieldName,
      direction: filter.direction
    }
  };
  return REQ_BODY;
};
